import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'hdw-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnChanges {
  @Input() canShow: boolean;
  public showLoader: boolean;
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['canShow'].currentValue) {
      this.showLoader = true;
    } else {
      setTimeout(() => {
        this.showLoader = false;
      }, 1000);
    }
  }
}
